<template>
    <WhiteIQOS :title="$t('merchant_quicklinks.title')" :subtitle="$t('merchant_quicklinks.subtitle')">
        <div class="gap-row-1xs">
            <div class="quicklink" v-for="(v, k) in quickLinks" :key="k">
                <a :href="v" target="_blank">{{ $t('merchant_quicklinks.links.' + k) }}</a>

                <BaseIconButton icon="copy" variant="fill" size="sm" @click="copyToClipboard(v)" />
            </div>
        </div>

    </WhiteIQOS>
</template>

<script>
import ClipboardService from '@/services/clipboard'

export default {
    computed: {
        quickLinks () {
            const base = {
                'terms_of_service': 'https://qrwaiter.com.ua/terms/',
                'privacy_policy': 'https://qrwaiter.com.ua/privacy_policy/'
            }

            if (this.offertMenuLink) {
                base['public_offert'] = this.offertMenuLink
            }

            return base
        },
        offertMenuLink () {
            const menuIds = [...(this.$store.state.cafe.menu_ids || []), ...(this.$store.state.cafe.delivery.menu_ids || [])]

            if (menuIds.length) {
                return `https://new.qrwaiter.com.ua/offert/${this.$store.state.cafe._id}/${menuIds[0]}`
            } else {
                return null;
            }
        }
    },
    methods: {
        copyToClipboard (value) {
            ClipboardService.copyToClipboard(value)

            this.$store.commit('ui/addToast', {
                variant: 'confirm',
                content: this.$t('notification_toast.confirm.copied')
            })
        },

    }
}
</script>
<style scoped>
.quicklink {
    display: flex;
    flex-direction: row;
    column-gap: 16px;
    align-items: center;
}

.quicklink a {
    color: var(--qrw-content-success-primary);
}
</style>